import { ReactElement } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonFunctionsCrumbs } from '../constants';
import FormFunction, { FunctionForm } from 'system/components/functions/form';
import { noop } from 'shell/utils/noop';
import { useParams, useNavigate } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { Functionality } from 'shell/models/functionality';
import { HttpResponse } from 'shell/models/http-response';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';

const FunctionsDetail = (): ReactElement => {
  const navigate = useNavigate();
  const params = useParams();

  const [functions] = useHttpFetch<HttpResponse<Functionality>, FunctionForm>(
    `${__MANAGEMENT_API_URL__}/funzioni/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: [],
      },
      transformer: (response) => {
        const dataFunction = response.data?.payload;
        return {
          id: dataFunction?.key?.codice.toString() || '',
          name: dataFunction?.nome || '',
          entity: dataFunction?.entita || '',
          event: dataFunction?.evento || '',
          contextLastUpdate: dataFunction?.note || '',
        };
      },
    }
  );

  const content =
    functions.pristine || functions.isLoading ? null : (
      <FormFunction
        title="Dettaglio Funzione"
        onOk={noop}
        onCancel={() => {
          navigate('/sistema/funzioni');
        }}
        disabled
        initialValues={functions.data as unknown as FunctionForm}
      />
    );

  return (
    <>
      <Breadcrumbs items={[...CommonFunctionsCrumbs, { name: 'Dettaglio Funzione' }]} />
      {content}
    </>
  );
};

FunctionsDetail.displayName = 'Functions Detail';

export default FunctionsDetail;
